import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAppDispatch } from '@/shared/lib';
import { createMenuActions } from './actions';

export const useMenuActions = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const actions = useMemo(() => createMenuActions(dispatch, navigate), [dispatch, navigate]);

  const localizedActions = useMemo(
    () =>
      actions.map((action) => ({
        ...action,
        label: action.labelKey ? t(action.labelKey, action.label) : action.label
      })),
    [actions, t]
  );

  return { actions: localizedActions };
};
